import { setupAxiosInterceptor } from 'network/config/axiosInterceptor';
import { queryClient } from 'network/config/queryKeys';
import { useEffect } from 'react';
import { QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';
import { AppNavigation } from './navigation/AppNavigation';
import ScrollToTop from './utils/scrollToTop';

export const App = () => {
  // Initialize Axios interceptor for session management
  useEffect(() => {
    setupAxiosInterceptor();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ScrollToTop />
        <AppNavigation />
      </BrowserRouter>
    </QueryClientProvider>
  );
};

export default App;
